import React from 'react';
import { Star } from 'lucide-react';
export function SocialProofSeal() {
  return <div className="bg-[#2D5016] text-white py-4" data-id="element-616">
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center justify-center gap-4 text-center" data-id="element-617">
        <div className="flex items-center gap-1" data-id="element-618">
          {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 fill-[#D4AF37] text-[#D4AF37]" data-id="element-619" />)}
        </div>
        <p className="font-medium text-lg" data-id="element-620">
          <span className="font-bold" data-id="element-621">Valorado 4.8/5</span> por más de{' '}
          <span className="font-bold text-[#D4AF37]" data-id="element-622">10.000 mujeres</span> en
          España
        </p>
      </div>
    </div>;
}